import React from 'react';
import { $t } from "@/modules/i18n";

export default ({ message }) => {
  return (
    <section className="time-container-new">
      <div id="time" style={{position: "relative", top: -160}}></div>
      <div className="time-title">{$t(message.title)}</div>
      <div className="content-container">
        <div className="time-list">
          {
            message.list.map((item, index) => {
              return (
                <div key={index} className="time-item">
                  <div className="item-icon">
                    <img src={item.icon}/>
                  </div>
                  <div className="order-wrapper">
                    <div className='up-divide'></div>
                    <div className="number">{`0${index + 1}`}</div>
                    <div className='down-divide'></div>
                  </div>
                  <div className="item-desc">
                    <div className="title">{$t(item.title)}</div>
                    <div className="date">{$t(item.date)}</div>
                    <div className="desc">{$t(item.text)}</div>
                    {item.tips && <div className="tips" dangerouslySetInnerHTML={{ __html: $t(item.tips) }} ></div>}
                  </div>
                </div>
              )
            })
          }
        </div>
        <ul className="explains">
          {
            message.explains.map((text, index) => {
              return (
                <li key={index} className="explain-item">{$t(text)}</li>
              )
            })
          }
        </ul>
      </div>
    </section>
  )
  
}